import { render, staticRenderFns } from "./Expediente.vue?vue&type=template&id=55f481ef&"
import script from "./Expediente.vue?vue&type=script&lang=js&"
export * from "./Expediente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports